/** Session id for the global authed-dashboard floating concierge (not landing hero). */
export const FLOATING_CONCIERGE_SESSION_KEY = "lembra:floating_concierge_session_id";
